'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.googleAnalyticsIndividualPayment = exports.enterprisePlanEnquiryAnalytics = exports.teamPlanEnquiryAnalytics = exports.individualPlanEnquiryAnalytics = exports.googleAnalyticsEmailReferralEvent = exports.googleAnalyticsFacebookReferralEvent = exports.googleAnalyticsTwitterReferralEvent = exports.googleAnalyticsReferralViewEvent = exports.googleAnalyticsPlanViewEvent = undefined;

var _intercomService = require('../../../analytics/intercomService');

var _googleAnalyticsService = require('../../../analytics/googleAnalyticsService');

var _analyticsConstants = require('../../../analytics/analyticsConstants');

var googleAnalyticsPaymentsEvent = function googleAnalyticsPaymentsEvent(eventAction) {
    return (0, _googleAnalyticsService.googleAnalyticsSend)({
        hitType: _analyticsConstants.GOOGLE_ANALYTICS_HIT_TYPES.event,
        eventCategory: 'Payments',
        eventAction: eventAction
    });
};

// Constants
// Analytics services
var googleAnalyticsPlanViewEvent = exports.googleAnalyticsPlanViewEvent = function googleAnalyticsPlanViewEvent() {
    return googleAnalyticsPaymentsEvent('plan-view');
};
var googleAnalyticsReferralViewEvent = exports.googleAnalyticsReferralViewEvent = function googleAnalyticsReferralViewEvent() {
    return googleAnalyticsPaymentsEvent('referral-view');
};

var googleAnalyticsReferralEvent = function googleAnalyticsReferralEvent(referralType) {
    return googleAnalyticsPaymentsEvent('plan-referral-' + referralType + '-click');
};

var googleAnalyticsTwitterReferralEvent = exports.googleAnalyticsTwitterReferralEvent = function googleAnalyticsTwitterReferralEvent() {
    return googleAnalyticsReferralEvent('twitter');
};
var googleAnalyticsFacebookReferralEvent = exports.googleAnalyticsFacebookReferralEvent = function googleAnalyticsFacebookReferralEvent() {
    return googleAnalyticsReferralEvent('facebook');
};
var googleAnalyticsEmailReferralEvent = exports.googleAnalyticsEmailReferralEvent = function googleAnalyticsEmailReferralEvent() {
    return googleAnalyticsReferralEvent('email');
};

var googleAnalyticsPlanEnquiryEvent = function googleAnalyticsPlanEnquiryEvent(subscriptionType) {
    return googleAnalyticsPaymentsEvent('plan-enquiry-' + subscriptionType + '-click');
};

var individualPlanEnquiryAnalytics = exports.individualPlanEnquiryAnalytics = function individualPlanEnquiryAnalytics() {
    return googleAnalyticsPlanEnquiryEvent('individual');
};
var teamPlanEnquiryAnalytics = exports.teamPlanEnquiryAnalytics = function teamPlanEnquiryAnalytics() {
    (0, _intercomService.intercomTrackEvent)('team-payment-enquiry');
    googleAnalyticsPlanEnquiryEvent('team');
};

var enterprisePlanEnquiryAnalytics = exports.enterprisePlanEnquiryAnalytics = function enterprisePlanEnquiryAnalytics() {
    (0, _intercomService.intercomTrackEvent)('enterprise-payment-enquiry');
    googleAnalyticsPlanEnquiryEvent('enterprise');
};

var googleAnalyticsIndividualPayment = exports.googleAnalyticsIndividualPayment = function googleAnalyticsIndividualPayment() {
    return googleAnalyticsPaymentsEvent('payment-individual');
};


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/plan/planEnquiryAnalyticsService.js
// module id = 235
// module chunks = 0